import React from 'react'
import illustration from '../../../../../static/images/illustrations/not-found.svg'
import styles from '../../Error.module.scss'

const NotFound = () => (
  <div className={styles['container']}>
    <img src={illustration} />
    <h1>Page Not Found</h1>
    <p>
      The page you were looking for has either been moved, deleted, or doesn't exist. Click <a href='/'>here</a> or the button below to go back home.
    </p>
    <div>
      <a href='/' className='btn btn-primary'>Take me back!</a>
    </div>
  </div>
)

export default NotFound
